import { useState, useEffect } from 'react';

import { IEvent, IEventData, IGroupedEvents } from '../types';

export default useGroupedEvents;

function useGroupedEvents(eventData: IEventData): IGroupedEvents | undefined {
  const [groupedEvents, setGroupedEvents] = useState<IGroupedEvents>();

  useEffect(() => {
    if (!eventData) return;
    if (eventData.totalEvents === 0) {
      // all events were read => resetting groupedEvents to undefined
      setGroupedEvents(undefined);
      return;
    }
    const { events } = eventData;

    setGroupedEvents(events.reduce(groupByArtist, {}));
  }, [eventData]);

  return groupedEvents;
}

function groupByArtist(
  accumulator: IGroupedEvents,
  event: IEvent
): IGroupedEvents {
  const id = event.relatedEntity.id;
  const artist = accumulator[id];

  if (artist) artist.push(event);
  else accumulator[id] = [event];

  return accumulator;
}
